import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ShowOperatorsService {
  constructor() {}

  showOperators = signal<boolean>(false);

  toggle(): void {
    this.showOperators.update(value => !value);
  }

  set(value: boolean): void {
    this.showOperators.set(value);
  }

  get(): boolean {
    return this.showOperators();
  }
}
